import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from './Non-Master/logger.service';
import { tConsultHeadModel,tConsultHeadLogModel, tConsultHeadModelWithPatientInfo, VoidVoucherListClass,backDayHistoryListClass, getHistoryBackDaySearchV3Model, tConsultHeadModelWithPatientInfoV3, VoidVoucherListClassV2, tConsultHeadModelWithPatientInfoV4 } from '../models/tConsultHeadModel';
import { tConsultDetailModel, tConsultDetailServiceModel } from '../models/tConsultDetailModel';
import { tConsultCertModel } from '../models/tConsultCertModel';
import { preDefineCate } from '../models/tItemCateModel';
import { ChangeUnpaidModel } from '../models/tChangeAcctModel';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { isNullOrUndefined } from 'util';
import { ResultModel } from './tPatient.service';
import { PostXRayModel, XRayQueueModel, tXRayModel } from '../models/XRay/tXRayModel';
import { onConsultSummaryModel, onConsultSummarysModel } from '../models/onConsultSummaryModel';
import { DateAdapter } from '@angular/material';




@Injectable({
    providedIn: 'root'
})

export class tOnConsultService {

    constructor(private http: HttpClient,
        private log: LoggerService,) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/onConsult';
    readonly pathName_BodyMap = '/tConsultBodyMapModels';
    readonly pathName_Cert = '/tConsultCertModels';
    readonly pathName_xray = this.baseurl + '/tXRayModels';

    canCreateBill(clthShopID:string,consultNumber:string){
      return this.http.get(`${this.baseurl + this.pathName}/CanCreateBill/${clthShopID}/${consultNumber}`);
    }

    changeClthTherapistID(consultNumber:string,employeeID:string){
      return this.http.put(`${this.baseurl + this.pathName}/changeTherapist/${consultNumber}`,{clthTherapistID:employeeID});
    }

    changeClthCaseDrID(consultNumber:string,employeeID:string){
      return this.http.put(`${this.baseurl + this.pathName}/changeConsultCaseDr/${consultNumber}`,{clthCaseDrID:employeeID});
    }

    //copyConsultFollowUp
    copyConsultDetails(fromConsultNumber:string,toConsultNumber:string){
      return this.http.post(this.baseurl + this.pathName +'/copyDetailDesc/'+fromConsultNumber+'/'+toConsultNumber,null);
    }

    copyConsultDiagonsis (fromConsultNumber:string,toConsultNumber:string){
      return this.http.post(this.baseurl + this.pathName +'/copyClthDiagonsis/'+fromConsultNumber+'/'+toConsultNumber,null);
    }

    getXRay(shopID:string,consultNumber:string){
      return this.http.get<tXRayModel[]>(`${this.pathName_xray}/${shopID}/${consultNumber}`);
    }

    getXRayQueue(shopID:string){
      return this.http.get<XRayQueueModel[]>(`${this.baseurl}${this.pathName}/xrays/${shopID}`);
    }

    postXRay(shopID:string,consultNumber:string,xrayItems:PostXRayModel[]){
      return this.http.post<any>(`${this.pathName_xray}/${shopID}/${consultNumber}`,xrayItems);
    }

    postXRayCompleted(shopID:string,consultNumber:string){
      return this.http.post<any>(`${this.pathName_xray}/xrayCompleted/${shopID}/${consultNumber}`,{});
    }

    summary(shopID:string,consultNumber:string){
      return this.http.get<onConsultSummaryModel>(`${this.baseurl}${this.pathName}/summary/${shopID}/${consultNumber}`);
    }

    summarys(shopID:string,date:string){
      return this.http.get<ResultModel>(`${this.baseurl}${this.pathName}/summarys/shopID/${shopID}/date/${date}`);
    }


    getOnConsultInfo(shopID: string, ConsultID: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tConsultHeadModelWithPatientInfo[]>(this.baseurl + this.pathName + '/GetOnConsultInfo/' + shopID + '/' + ConsultID);
    }

    getOnConsultInfoV3(shopID: string, ConsultID: string) {
      // tslint:disable-next-line:max-line-length
      return this.http.get<tConsultHeadModelWithPatientInfoV3[]>(this.baseurl + this.pathName + '/GetOnConsultInfo/' + shopID + '/' + ConsultID);
    }

    getOnConsultInfoV4(shopID: string, ConsultID: string) {
      // tslint:disable-next-line:max-line-length
      return this.http.get<tConsultHeadModelWithPatientInfoV4[]>(this.baseurl + this.pathName + '/GetOnConsultInfo/' + shopID + '/' + ConsultID);
    }

    getTreatmentBodyInfo(shopID: string, diagonsisItemCateID: string) {

        if (diagonsisItemCateID === '') {
            diagonsisItemCateID = preDefineCate.diagonsis;
        }

        return this.http.get<any[]>(this.baseurl + this.pathName_BodyMap
            + '/GetTreatmentBodyInfo/' + shopID + '/' + diagonsisItemCateID);
    }

    getSavedConsultLine(shopID: string, ConsultID: string, isDiagonsis: string, diagonsisItemCateID: string)
    {
        if (diagonsisItemCateID === '') {
            diagonsisItemCateID = preDefineCate.diagonsis;
        }

        // tslint:disable-next-line:max-line-length
        return this.http.get<tConsultDetailServiceModel[]>(this.baseurl + this.pathName + '/GetSavedConsultLine/'
        + shopID + '/' + ConsultID + '/' + isDiagonsis + '/' + diagonsisItemCateID);
    }

    getSavedConsultCert(shopID: string, ConsultID: string, patientID: string)
    {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tConsultCertModel[]>(this.baseurl + this.pathName_Cert + '/'
        + shopID + '/' + ConsultID + '/' + patientID);
    }

    completedConsultService(shopID:string,consultNumber:string,data:any[]){
      return this.http.post<any>(this.baseurl + this.pathName + `/serviceCompleted/${shopID}/${consultNumber}`,data);
    }

    getConsultServiceCompleteStatus(shopID:string,consultNumber:string){
      return this.http.get<any>(this.baseurl + this.pathName + `/serviceCompleteStatus/${shopID}/${consultNumber}`);
    }

    saveConsult(data: any, isDiagonsis: string, diagonsisItemCateID: string) {

        if (diagonsisItemCateID === '') {
            diagonsisItemCateID = preDefineCate.diagonsis;
        }

        return this.http.post(this.baseurl + this.pathName + '/Formatted/SaveConsult/'
        + isDiagonsis + '/' + diagonsisItemCateID, data);
    }

    SaveConsultDiagnosisInfo(data: any, isDiagonsis: string, diagonsisItemCateID: string) {

        if (diagonsisItemCateID === '') {
            diagonsisItemCateID = preDefineCate.diagonsis;
        }

        return this.http.post(this.baseurl + this.pathName + '/Formatted/SaveConsultDiagnosisInfo/'
        , data);
    }

    saveConsultService(data: any, isDiagonsis: string, diagonsisItemCateID: string) {

        if (diagonsisItemCateID === '') {
            diagonsisItemCateID = preDefineCate.diagonsis_service;
        }

        return this.http.post(this.baseurl + this.pathName + '/Formatted/SaveConsultService/'
        + isDiagonsis + '/' + diagonsisItemCateID, data);
    }




    saveCert(data: tConsultCertModel, shopID: string, ConsultID: string, patientID: string) {

        return this.http.put(this.baseurl + this.pathName_Cert + '/Formatted/SaveCert/'
        + shopID + '/' + ConsultID + '/' + patientID, data);
    }




    addConsultService (data: tConsultDetailServiceModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/AddConsultService/', data);
    }

    delConsultService (id: string) {
        return this.http.delete(this.baseurl + this.pathName + '/Formatted/DeleteConsultService/' + id);
    }

    updateConsultService (data: tConsultDetailServiceModel, para: string, duration: number) {
        return this.http.put(this.baseurl + this.pathName + '/Formatted/UpdateConsultService/'
        + data.id + '/' + para + '/' + duration, data);
    }

    updateConsultServiceByModel (id: number, data: tConsultDetailServiceModel) {
        return this.http.put(this.baseurl + this.pathName + '/Formatted/updateConsultServiceByModel/' + id, data);
    }




    getOnConsultLog(shopID: string, patientID: string) {
        // tslint:disable-next-line:max-line-length
        return this.http.get<tConsultHeadLogModel[]>(this.baseurl + this.pathName + '/GetOnConsultLog/' + shopID + '/' + patientID);
    }

    getVoidVoucherList(shopID: string,patientID: string) {
        return this.http.get<VoidVoucherListClass[]>(this.baseurl + '/tConsultHeadModels/GetVoidVoucherListByPatientID/'+shopID+'/'+ patientID);
    }

    getVoidVoucherListCurrentDate(shopID: string) {
        // return this.http.get<VoidVoucherListClass[]>(this.baseurl + '/tConsultHeadModels/GetVoidVoucherListSelectedByCurrentDate/'+shopID);

        //test - get paymentNumber one by one
        return this.http.get<VoidVoucherListClassV2[]>(this.baseurl + '/tConsultHeadModels/GetVoidVoucherListSelectedByCurrentDate/v3/'+shopID);
    }

    getVoidVoucherListBackDay(shopID: string) {
        return this.http.get<VoidVoucherListClass[]>(this.baseurl + '/tConsultHeadModels/GetVoidVoucherListBackDay/'+shopID);
    }

    getVoidVoucherListBackDaySearch(shopID: string,patientID: string,patientChiName:string ,bpInvoiceNumber:string,consultNumber : string ,dateFrom:string,dateTo:string) {
        return this.http.get<VoidVoucherListClass[]>(this.baseurl + '/tConsultHeadModels/getVoidVoucherListBackDaySearch/'+shopID+'/'+patientID
        +'/'+patientChiName + '/'+bpInvoiceNumber+ '/' +consultNumber+'/'+dateFrom+'/'+dateTo);
    }

    getHistoryBackDaySearch(shopID: string,patientID: string,patientChiName:string ,bpInvoiceNumber:string,consultNumber : string ,dateFrom:string,dateTo:string,paymentNumber:string) {
      return this.http.get<backDayHistoryListClass[]>(
        this.baseurl + `/tConsultHeadModels/getHistoryBackDaySearch/v2/${shopID}/${patientID}/${patientChiName}/${bpInvoiceNumber}/${consultNumber}/${dateFrom}/${dateTo}/${paymentNumber}`
        );
    }

    getHistoryBackDaySearchV3(shopID: string,patientID: string,patientChiName:string ,bpInvoiceNumber:string,consultNumber : string ,dateFrom:string,dateTo:string,paymentNumber:string) {
      return this.http.get<getHistoryBackDaySearchV3Model[]>(
        this.baseurl + `/tConsultHeadModels/getHistoryBackDaySearch/v3/${shopID}/${patientID}/${patientChiName}/${bpInvoiceNumber}/${consultNumber}/${dateFrom}/${dateTo}/${paymentNumber}`
        );
    }

    getHistoryBackDaySearchV4(shopID: string,patientID: string,patientChiName:string ,bpInvoiceNumber:string,consultNumber : string ,dateFrom:string,dateTo:string,treatID:string,paymentNumber:string,clthDiagonsis?:string ) {

      const data = new HistoryBackDaySearchRequest();
      data.shopID = shopID;
      data.patientID = patientID;
      data.patientChiName = patientChiName;
      data.bpInvoiceNumber = bpInvoiceNumber;
      data.consultNumber = consultNumber;
      data.dateFrom = dateFrom;
      data.dateTo = dateTo;
      data.paymentNumber = paymentNumber;
      data.clthDiagonsis = clthDiagonsis? clthDiagonsis : null;
      data.treatID=treatID;

      return this.http.post<any[]>(
        this.baseurl + `/tConsultHeadModels/HistoryBackDaySearch`,data);
    }

    getChangeUnpaidList(changeID: string){
        return this.http.get<ChangeUnpaidModel[]>(this.baseurl + '/tConsultHeadModels/GetUnpaidChangeRecord/'+ changeID);
    }



    // Phase 2 with LMDs Storing
    addConsultServiceP2 (data: tConsultDetailServiceModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/AddConsultServiceP2/', data);
    }

    updateConsultServiceByModelP2 (id: number, data: tConsultDetailServiceModel, type: string) {
        return this.http.put(this.baseurl + this.pathName + '/Formatted/updateConsultServiceByModelP2/' + id + '/' + type, data);
    }

    getConsultStatus(consultNumber:string){
      return this.http.get<ConsultStatusResponse>(this.baseurl + '/tConsultHeadModels/CTStatus/'+ consultNumber);
    }

    getLastPhysioInfo(shopID:string , patientID:string){
      return this.http.get<any>(this.baseurl + this.pathName + '/lastPhysioInfo/' + shopID + '/' + patientID);
    }

    getPrintXrayLabel(shopID:string,consultNumber:string){
      return this.http.get<ResultModel>(`${this.pathName_xray}/labelPrint/${shopID}/${consultNumber}`);
    }

    getPrintClinicalNotes(consultNumber:string){
      return this.http.get<ResultModel>(`${this.baseurl + this.pathName}/clinicalNotes/${consultNumber}`);
    }

    getCTStatus(consultNumber:string){
      return this.http.get<CTStatusResponse>(`${this.baseurl + this.pathName}/ctStatus/${consultNumber}`);
    }

}

export class CTStatusResponse{
  isToday:boolean;
  editDiagnosis:boolean;
  editNotesAndDrOrder:boolean;
}

export class ConsultStatusResponse{
  clthConsultNumber:string;
  clthBillingNumber:string;
  clthBillingStatus:string;
}

export class HistoryBackDaySearchRequest{
  shopID:string;
  patientID:string;
  patientChiName:string;
  bpInvoiceNumber:string;
  consultNumber:string;
  dateFrom:string;
  dateTo:string;
  paymentNumber:string;
  clthDiagonsis:string;
  treatID:string;
}
